import { productsUrl, taxesUrl } from "../resources";
import getRequest from '../common/getRequest.js'

async function getProductsByRestaurant(restaurantId, token) {
    let url = `${productsUrl}/getbyrestaurant/${restaurantId}`;
    let data;
    await getRequest.getDataWithToken(url, token)
                .then(res => {
                    data = res.items
                });
    return data;
}

async function getTaxesByRestaurant(restaurantId, token) {
    let url = `${taxesUrl}/getbyrestaurant/${restaurantId}`;
    let data;
    await getRequest.getDataWithToken(url, token)
                .then(res => {
                    data = res.taxes
                });
    return data;
}

export default {
    getProductsByRestaurant,
    getTaxesByRestaurant
}